/* eslint-disable no-console */
import { WorkerEvent, AppSocketType } from 'Modules'
import { all, call, put, select } from 'typed-redux-saga'
import {
	chatSelectors,
	ChatSocketChannel,
	ChatSocketNS,
	chatSocketSelector,
	chatSocketSlice,
	WsCommands,
} from 'Pages/chat'
import { createChatWorker } from './createChatWorker'

function subscribeChannel(channel: ChatSocketChannel, chat_id?: number) {
	navigator.serviceWorker?.controller?.postMessage({
		appSocketType: AppSocketType.UNI_CHAT,
		data: {
			type: WorkerEvent.SEND_MESSAGE,
			payload: JSON.stringify({
				command: WsCommands.SUBSCRIBE,
				identifier: `{"channel": "${channel}", ${chat_id ? `"chat_id": ${chat_id}}` : ''}`,
			}),
		},
	})
}

export function* subscribeChatChannels(action: ChatSocketNS.Channels) {
	const currentChat = yield* select(chatSelectors.currentChat)
	const chat_id = currentChat?.id
	if (!('serviceWorker' in navigator)) return
	try {
		if (action.payload.length) {
			const prevChannels = yield* select(chatSocketSelector.selectChannels)
			yield* put(
				chatSocketSlice.actions.setChannels(new Set([...action.payload, ...[...prevChannels]]))
			)
		}

		if (!(yield* select(chatSocketSelector.selectHasWorker))) yield* call(createChatWorker)

		const channels = yield* select(chatSocketSelector.selectChannels)
		yield* all([...channels].map((channel) => call(subscribeChannel, channel, chat_id)))
	} catch (e) {
		console.log(e)
	}
}
